import * as React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { useRouteLoaderData } from "react-router-dom"
import { inspectionsByFilter, setUpcomingCategory } from "@app/utils/inspections"
import Box from "@app/components/Box"
import OfficeSwitch from "@app/components/OfficeSwitch"
import PageWrapper from "@app/components/PageWrapper"
import * as styles from "./index.module.scss"

import Config from "@app/constants/Config"

export async function loader (/*request*/) {
	return {}
}

export default function Index () {
	const { office, inspections } = useRouteLoaderData("root")
	const upcomingInspections = setUpcomingCategory(inspectionsByFilter(inspections, "upcoming"), office)
	return (
		<PageWrapper vBetween={true}>
			<Container>
				<Row>
					<Col className={"mb-6"}>
						<h1 className={"mb-0"}>Übersicht</h1>
						<p className={"text-small text-dim"}>Was möchten Sie als nächstes tun?</p>
					</Col>
				</Row>
				<Row>
					<Col>
						<h2 className={styles['category-hl']}>Arbeitsplatzbesichtigung</h2>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<Box
							headline={"Neu"}
							link={`${Config.BASE_PATH}/inspection/new-initial`}
						/>
					</Col>
					<Col xs={12}>
						<Box
							headline={"In Bearbeitung"}
							count={inspectionsByFilter(inspections, "initial-in-progress").length}
							link={`${Config.BASE_PATH}/inspections/initial-in-progress`}
						/>
					</Col>
					<Col xs={12}>
						<Box
							headline={"Ausstehende Übertragungen"}
							count={inspectionsByFilter(inspections, "unsynchronized").length}
							link={`${Config.BASE_PATH}/inspections/unsynchronized`}
						/>
					</Col>
				</Row>
				<Row>
					<Col>
						<h2 className={styles['category-hl']}>Folgebesichtigungen</h2>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<Box
							headline={"Anstehende Besichtigungen"}
							count={upcomingInspections.length}
							link={`${Config.BASE_PATH}/inspections/upcoming`}
							info={{
								accident: upcomingInspections.filter(({ upcomingCategory }) => upcomingCategory === "accident").length,
								dueUrgent: upcomingInspections.filter(({ upcomingCategory }) => upcomingCategory === "dueUrgent").length,
								dueSoon: upcomingInspections.filter(({ upcomingCategory }) => upcomingCategory === "dueSoon").length,
							}}
						/>
					</Col>
					<Col xs={12}>
						<Box
							headline={"In Bearbeitung"}
							count={inspectionsByFilter(inspections, "follow-up-in-progress").length}
							link={`${Config.BASE_PATH}/inspections/follow-up-in-progress`}
						/>
					</Col>

				</Row>
				<Row>
					<Col>
						<h2 className={styles['category-hl']}>Archiv</h2>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<Box
							headline={"Abgeschlossene Besichtigungen"}
							count={inspectionsByFilter(inspections, "archive").length}
							link={`${Config.BASE_PATH}/inspections/archive`}
						/>
					</Col>

				</Row>
				<Row>
					<Col>
						<h2 className={styles['category-hl']}>Feedback</h2>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<Box
							headline={"Feed&shyback senden"}
							link={`${Config.BASE_PATH}/feedback`}
						/>
					</Col>
				</Row>
			</Container>

			<Container className={"mt-60"}>
				<Row>
					<Col>
						<OfficeSwitch label={office.Branch} link={`${Config.BASE_PATH}/office`} />
					</Col>
				</Row>
				<Row>
					<Col className={"text-end"} style={{ position: "relative" }}>
						<span className={"text-small .text-dim .small"}
							  style={{ position: "relative", top: "1em" }}>{Config.VERSION}</span>
					</Col>
				</Row>
			</Container>
		</PageWrapper>
	)
}
